import React, { useEffect, useRef } from 'react';
/**
 * LongDivisionRenderer — Wrapper adapting LongDivision to renderer interface.
 *
 * DDD co-locatie: moved from components/practice/renderers/ in s66.
 */

import { QuestionRendererProps } from './types';
import { LongDivision } from '../LongDivision';
export function LongDivisionRenderer({
  question,
  onAnswer,
  onReadyChange,
  shouldValidate
}: QuestionRendererProps) {
  const hasValidatedRef = useRef(false);
  useEffect(() => {
    hasValidatedRef.current = false;
  }, [question.id]);
  useEffect(() => {
    if (!shouldValidate) {
      hasValidatedRef.current = false;
    }
  }, [shouldValidate]);
  const handleComplete = (userAnswer: string) => {
    if (!hasValidatedRef.current) {
      hasValidatedRef.current = true;
      onAnswer(userAnswer);
    }
  };
  return <LongDivision question={question} onComplete={handleComplete} onReadyChange={onReadyChange} shouldValidate={shouldValidate} data-id="element-8599" />;
}